var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-col-12 p-d-flex p-jc-between p-ai-center"},[_c('Button',{staticClass:"p-button-raised",attrs:{"label":"Unirse a la Sesión"},on:{"click":function($event){return _vm.goVideoConference()}}}),_vm._v(" "),_c('Checkbox',{staticClass:"p-ml-4",attrs:{"value":_vm.checks.find(function (e) { return e.lesson_id === _vm.lesson.id; }) || {
        lesson_id: _vm.lesson.id,
      },"disabled":true},model:{value:(_vm.checks),callback:function ($$v) {_vm.checks=$$v},expression:"checks"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d7ac91d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Leccion/StudenLessonMeeting.vue
// module id = CTZV
// module chunks = 38